import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo component
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix
import { providersCasino } from '../../../../config/config'; // Importing casino providers configuration
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the filter deposit reports view.
 */
export default class FilterDepositReportsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Getting screen size configuration

        // Datepicker configuration
        const fecha = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Localized label for date
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
            ],
        };

        // Transaction ID input configuration
        const transactionId = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'TransactionId',
                    type: 'number',
                    label: _('Transacción ID'), // Localized label for transaction ID
                    labelPosition: 'top',
                    placeholder: _('Transacción ID'), // Placeholder text
                    invalidMessage: _('Transacción ID is required'), // Validation message
                },
            ],
        };

        // Upper section containing filters
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [
                        fecha, // Datepicker
                        {
                            view: 'richselect',
                            name: 'Type',
                            localId: 'provider:combo',
                            label: _('Tipo'), // Localized label for type
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                { id: '0', value: _('Mensual') }, // Monthly option
                                { id: '1', value: _('Diario') }, // Daily option
                            ],
                        },
                    ],
                },
            ],
        };

        // Buttons for clearing and submitting the form
        const buttons = {
            margin: 10,
            minWidth: 200,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Localized label for clear button
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form fields
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Localized label for consult button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('depositReport:filter', [
                            filterdata, // Triggering filter event with form data
                        ]);
                        $$('b5').collapse(); // Collapse the filter section
                    },
                },
            ],
        };

        // Accordion section for filters
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Localized header for filters
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Including upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        // Returning the main form configuration
        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section], // Main content of the form
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
